module.exports = __webpack_public_path__ + "static/media/deezer.b1970ef6.png";